import React from 'react';
import { prop } from 'ramda';
import { NOTIFICATION_TYPES } from 'js/components/common/Notifications/constants';
import { useInitTranslations } from 'js/hooks/i18n';
import { componentService } from 'js/services/component.service';
import Notification from './Notification';
import AcceptDeclineNotification from './AcceptDeclineNotification';
import translations from './translations';
import { useCustomSelector } from 'js/store/hooks';
import { NOTIFICATIONS_REDUCER } from 'js/store/constants';

import style from './index.scss';

export const notificationMap = {
    [NOTIFICATION_TYPES.DEFAULT]: Notification,
    [NOTIFICATION_TYPES.ACCEPT_DECLINE]: AcceptDeclineNotification
};

export const Notifications = () => {
    const notifications = useCustomSelector(NOTIFICATIONS_REDUCER, prop('notifications'));

    useInitTranslations(translations);

    return (
        <div className={style.notifications}>
            {notifications.map((notification, index) => {
                const Item = notificationMap[notification.type];

                return <Item
                    key={notification.id}
                    index={index}
                    {...notification}
                />;
            })}
        </div>
    );
};

componentService.registerWebContentComponents({ Notification });
